import { Injectable, OnDestroy, inject, signal } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, filter, Subscription } from 'rxjs';
import { RoutesExtended, SidebarData } from '../sidebar-types';

@Injectable()
export class SidebarService implements OnDestroy{
  private pageMap: Map<String, SidebarData> = new Map();
  readonly drawerWidth$ = new BehaviorSubject<number>(0);
  private ro?: ResizeObserver;
  public drawer: MatDrawer;

  opened$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private drawerSub = new Subscription();

  public pages = signal([]);

  constructor(public route: ActivatedRoute, public router: Router) {}

  setSidebarRoutes(mapRoutes: RoutesExtended) {
    mapRoutes
      .filter((page) => page.data)
      .sort((a, b) => a.data.sidebar.position - b.data.sidebar.position)
      .forEach((page) =>
        this.pageMap.set(
          page.path.includes('/:') ? page.path.split('/:')[0] : page.path,
          page.data.sidebar
        )
      );


    this.pages.set(Array.from(this.pageMap, (v) => v[1]));

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.deactivateAllPages();
        let url = event.urlAfterRedirects;
        let pageName = url.split('/')[2];
        if (this.pageMap.has(pageName)) {
          this.pageMap.get(pageName).active = true;
        }
      });
  }

  setDrawer(drawer: MatDrawer) {

    this.drawerSub.unsubscribe();

    this.drawer = drawer;


    this.opened$.next(drawer.opened);

    this.drawerSub = drawer.openedChange.subscribe(state => {
      this.opened$.next(state);
      this.pushWidth()
    });

    this.ro = new ResizeObserver(() => this.pushWidth());
    this.ro.observe((drawer as any)._elementRef.nativeElement);
  }

  private pushWidth() {
    const el = (this.drawer as any)?._elementRef.nativeElement as HTMLElement | undefined;
    this.drawerWidth$.next(el ? el.getBoundingClientRect().width : 0);
  }

  close() {
    this.drawer.close();
  }

  open() {
    this.drawer.open();
  }

  getPageMap() {
    return this.pageMap;
  }

  private deactivateAllPages() {
    this.pageMap.forEach((page) => (page.active = false));
  }

  ngOnDestroy() {
    this.drawerSub.unsubscribe();
    this.opened$.complete();
    this.drawerWidth$.complete();
  }
}
